import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MessageAlert} from '@techsee/techsee-ui-common/lib/message-alert';
import {TsDashboardTitle} from '../ts-dashboard-title/component';
import {TsImageEditor} from '../ts-image-editor/ts-image-editor';
import {TsImageEditTools} from '../ts-image-edit-tools';
import {ITsWidgetsController} from './ts-widgets.controller';
import './ts-widgets.style.scss';

export interface TsWidgetsProps {
    controller: ITsWidgetsController;
}

@observer
export class TsWidgets extends TechseeBaseComponent<TsWidgetsProps> {
    renderInternal(): JSX.Element {
        const {controller} = this.props;

        if (!controller || !controller.showImageWidget) {
            return <React.Fragment />;
        }

        return (
            <div className='image-edit-container'>
                {controller.showDashboardTitle ? (
                    <TsDashboardTitle
                        dashboardState={controller.dashboardState}
                        handleAction={controller.handleDashboardTitleAction}
                        showMuteButton={controller.displayAudioButton && controller.dashboardState.useNewInterface}
                        toggleMute={controller.videoModeController.toggleMute}
                    />
                ) : null}

                {controller.showMessageAlert && controller.messageAlert ? (
                    <MessageAlert
                        className='use-common-styles message-alert-audio'
                        color={controller.messageAlert.color}
                        label={controller.messageAlert.label}
                    />
                ) : null}

                <div className='dashboard-main-image-container'>
                    <TsImageEditor controller={controller.imageEditorController} />
                </div>
                {/*<div className='ts-image-edit-tools-container'>*/}
                {/*    /!*{controller.showImageEditTools ? (*!/*/}
                {/*        <div className='ts-image-edit-tools'>*/}
                {/*            <TsImageEditTools controller={controller.imageEditToolsController} />*/}
                {/*        </div>*/}
                {/*    /!*) : null}*!/*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default TsWidgets;
